import {
    SET_COMPETITION,
    SET_NIVEAUX_COMPETITION,
    SET_LISTE_COMPETITION,
    SET_CATEG_AGE,
    SET_CATEG_GRADE,
    SET_CATEG_POIDS,
} from './mutations-type'

var _ = require('underscore');

// initial state
const state = {
    competition: null,
    textes: null,
    niveaux_competition: [],
    liste_competition: [],
    categ_age: [],
    categ_grade: [],
    categ_poids: [],
}

// mutations
const mutations = {
    [SET_COMPETITION](state, message) {
        state.competition = message;
    },
    [SET_NIVEAUX_COMPETITION](state, message) {
        state.niveaux_competition = message;
    },
    [SET_LISTE_COMPETITION](state, message) {
        state.liste_competition = message;
    },
    [SET_CATEG_AGE](state, message) {
        state.categ_age = message;
    },
    [SET_CATEG_GRADE](state, message) {
        state.categ_grade = message;
    },
    [SET_CATEG_POIDS](state, message) {
        state.categ_poids = message;
    },
}

const actions = {
    setCompetition({commit}, msg) {
        commit(SET_COMPETITION, msg)
    },
    setNiveauxCompetition({commit}, msg) {
        commit(SET_NIVEAUX_COMPETITION, msg)
    },
    setListeCompetition({commit}, msg) {
        commit(SET_LISTE_COMPETITION, msg)
    },
    setCategAge({commit}, msg) {
        commit(SET_CATEG_AGE, msg)
    },
    setCategGrade({commit}, msg) {
        commit(SET_CATEG_GRADE, msg)
    },
    setCategPoids({commit}, msg) {
        commit(SET_CATEG_POIDS, msg)
    },
}

const getters = {
    getCompetition: state => {
        return state.competition;
    },
    getNiveauxCompetition: state => {
        return state.niveaux_competition;
    },
    getCategAge: state => {
        return state.categ_age;
    },
    getCategGrade: state => {
        return state.categ_grade;
    },
    getCategPoids: state => {
        return state.categ_poids;
    },
    getListeCompetition: state => {
        return state.liste_competition;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/store-competition.js